module.exports = __webpack_public_path__ + "static/img/swiper3.696f1cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swiper3.jpg
// module id = fWwa
// module chunks = 1